angular.module('SpidApp')

.factory('ConversionRounded',
        ['_',
function (_) {
  var ConversionRounded = {

    /**
    * Get the minimal coin of a currency
    * @param coins : coins tab which contains all coins of the currnecy applied to an agency
    * @return the minimal coin
    **/
    getMinCoins: function (coins){
      //Checks parameter
      if(!coins){
        throw('ConversionRounded::getMinCoins - Missing parameter');
      }

      if(coins.length < 1){
        throw('ConversionRounded::getMinCoins - Missing coins');
      }

      return + _.min(coins);
    },


    /**
    * Convert ref price in the local price of product 
    * @param agencyCurrency : currency of the agency
    * @param localPrice : local price of a product in a agency
    * @return the arrounded price of the product
    **/
    fromRef: function (agencyCurrency, localPrice) {
      if (!agencyCurrency || localPrice === undefined || localPrice === null) {
        throw('ConversionRounded::fromRef() - Missing parameters');
      }

      // Product is free, no need to convert
      if(localPrice === 0){
        return 0;
      }

      // Get the min coin of the currency
      var minCoin = + ConversionRounded.getMinCoins(agencyCurrency.coins);

      // the local price is lower than the min coin, so we return the min coin in default
      if(localPrice < minCoin){
        return + minCoin;
      }

      // Convert the price
      var moduloRounded = + Math.round((localPrice % minCoin)*100)/100;
      var arroundedPrice = 0;

      if(moduloRounded < minCoin/2 ){
        arroundedPrice = localPrice - moduloRounded; 
      }else{
        arroundedPrice = localPrice + (minCoin - moduloRounded);
      }

      return + arroundedPrice.toFixed(2);
    }

  };

  return ConversionRounded;
}]);